<parkour-info-card [icon]="icon()" [style]="infoCardStyle()">
    <div class="flex flex-col gap-y-2">
        <p class="typo-body variant-body-fat">{{ title() }}</p>

        <ng-content></ng-content>
    </div>
</parkour-info-card>